import React from 'react';
import { Box, Typography } from '@mui/material';
import HighlightsBullets from './HighlightsBullets';

export default function Footer() {
    return (
        <Box marginTop={10}>
            <Box
                sx={{
                    backgroundColor: '#000000',
                    justifyContent: 'center',
                    textAlign: 'center',
                    paddingY: 6,
                    paddingX: 10,
                    minHeight: '30vh',
                    '@media (max-width:600px)': {
                        paddingY: 2,
                        paddingX: 3
                    }
                }}
            >
                <Typography
                    sx={{
                        color: '#FFF',
                        fontFamily: 'Poppins',
                        fontSize: '32px',
                        fontWeight: 700,
                        lineHeight: '133.4%',
                        marginBottom: 4,
                        '@media (max-width:600px)': {
                            fontSize: '24px',
                            marginBottom: 2.5
                        }
                    }}
                >
                    Highlights
                </Typography>
                <HighlightsBullets />
            </Box>
        </Box>
    );
}
